import React, { useState } from "react";
import { Field, reduxForm } from "redux-form";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { Col } from "react-bootstrap";
import { QUOTE_TYPE } from "MODULES/OutgoingQuotes/constants";
import {
  Form as AppForm,
  AutoCompleteField,
  CurrencyField,
  FormInput,
  Select,
  TextArea,
  Check,
  CheckGroup
} from "MODULES/shared/components/Forms";
import { toOptions } from "LIB/forms";
import { properCase } from "LIB/formatters/text";
import { NO_QUOTE, STANDARD } from "MODULES/IncomingQuotes/constants";
import { COMPANY_ID, COST, QUANTITY } from "APP_ROOT/constants";
import api from "APP_ROOT/api";
import { CONDITION, LEAD_TIME, PART_ID } from "MODULES/inventories/constants";
import { CONDITION_TYPES } from "MODULES/inventories/components/Detail/Dummies/constants";
import { connect } from "react-redux";
import { NOTE } from "MODULES/shared/constants";
import { createRequiredComponent } from "MODULES/RepairOrders/actions";
import { withFieldAccessors } from "MODULES/shared/decorators/withFieldAccessors";
import validate from "./validate";

const FORM_NAME = "requiredComponentForm";

const QUOTE_TYPES = {
  [STANDARD]: {
    label: "Standard",
    abbrev: "Std"
  },
  [NO_QUOTE]: {
    label: "No Quote",
    abbrev: "NQ"
  }
};

function Form(props) {
  const [company, setCompany] = useState(props.company);
  const [selectedPart, setSelectedPart] = useState();
  const searchParts = filter =>
    api.parts
      .search({ search_type: "search", part_number: filter })
      .then(({ data: { results } }) => results);

  const searchCompanies = filter =>
    api.companies
      .search({ filter, page: 1, limit: 20 })
      .then(resp => resp.data.results);

  return (
    <AppForm {...props}>
      <AppForm.Body>
        <FormRow>
          <Col md={6}>
            <Field
              name={QUOTE_TYPE}
              component={Select}
              options={toOptions(QUOTE_TYPES)}
              label={properCase(QUOTE_TYPE)}
              required
            />
          </Col>
          <Col md={6}>
            <Field
              name={COMPANY_ID}
              label="Vendor"
              placeholder="Search by typing a company's name or code"
              component={AutoCompleteField}
              formatItem={result => result && result.name}
              search={searchCompanies}
              disabled
              onItemSelected={i => i && setCompany(i)}
              selectedItem={company}
              required
            />
          </Col>
        </FormRow>
        <FormRow>
          <Col md={3}>
            <Field
              name={PART_ID}
              label="Part #"
              placeholder="Type a part's number..."
              component={AutoCompleteField}
              search={searchParts}
              selectedItem={selectedPart}
              formatItem={result => result && result.part_number}
              onItemSelected={i => i && setSelectedPart(i)}
              required
            />
          </Col>
          {props.getFieldValue(QUOTE_TYPE) === STANDARD && [
            <Col md={3}>
              <Field
                name={CONDITION}
                component={Select}
                options={toOptions(CONDITION_TYPES)}
                label={properCase(CONDITION)}
                required
              />
            </Col>,
            <Col md={2}>
              <Field
                name={QUANTITY}
                component={FormInput}
                label="Qty"
                required
              />
            </Col>,
            <Col md={2}>
              <CurrencyField name={COST} label="COST" required />
            </Col>,
            <Col md={2}>
              <Field
                name={LEAD_TIME}
                component={FormInput}
                label="Lead Time (Days)"
                required
              />
            </Col>
          ]}
        </FormRow>
        <FormRow>
          <Col md={4}>
            <CheckGroup checkGroupStyles={{ marginTop: 0 }} justified>
              <Field
                name="create_incoming_quote"
                component={Check}
                label="Create Incoming Quote"
              />
            </CheckGroup>
          </Col>
        </FormRow>
        <FormRow>
          <Col md={5}>
            <Field
              name={NOTE}
              component={TextArea}
              label="Note (Applied to the line item)"
              rows={5}
            />
          </Col>
        </FormRow>
      </AppForm.Body>
    </AppForm>
  );
}

export default connect(undefined, (dispatch, ownProps) => ({
  onSubmit: data =>
    dispatch(createRequiredComponent(ownProps.lineItem.id, data))
}))(
  reduxForm({
    form: FORM_NAME,
    validate
  })(withFieldAccessors(Form))
);



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/LineItemControls/RequiredComponents/Form.jsx